import Axios from "axios";

export class MonitoreoService {

    listado(url, params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${url}?${queryParams}`).then(res => res.data);
    }

    nuevo(data, url) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/${url}`, data).then(res => res.data);
    }

    editar(data, url) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/${url}`, data).then(res => res.data);
    }

    consultar(id, url, params = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${url}/${id}`, { params }).then(res => res.data);
    }

    eliminar(id, url, params = {}) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/${url}/${id}`, { params }).then(res => res.data);
    }

    listarMonitoreos(data, url) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${url}`, { params: data }).then(res => res.data);
    }

    generar(url, tipo, id) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${url}/${tipo}/${id}`,
            { headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob' }).then(async res => res);
    }

    generarDocumento(url, params = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${url}`, {
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob', params
        }).then(async res => res);
    }

    consultarInfo(url, params = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${url}`, { params }).then(res => res.data);
    }

    autoLista(urls, nombre) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${urls}/${encodeURIComponent(nombre)}`).then(res => res.data);
    }

    autoListaMatriz(url, nombre, matrizId) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${url}`, { params: { nombre, matrizId } }).then(res => res.data);
    }

    descargar(urls, info) {
        const headers = { 'Content-Type': 'application/json', 'Pragma': 'no-cache' };
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/${urls}/${info}`, { headers: headers, responseType: 'blob' }).then(async res => res.data);
    }

    subirArchivoHibrido(url, formData) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/${url}`, formData, { headers: { 'Content-Type': 'multipart/form-data', 'Pragma': 'no-cache' }, responseType: "blob" }).then(res => res);
    }
}
